export const BlockQuote = 'blockquote';
